<template>
  <div class="detailContainer">
    <div class="detailContent">
      <van-cell-group>
        <van-field
          v-model="info.releaseNumber"
          label="放行号："
          readonly
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.itemType"
          label="物品类型："
          readonly
          v-if="info.releaseType == 1"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.createrDepartment"
          label="部门："
          readonly
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.createrName"
          label="申请人："
          readonly
          label-width="100px"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="info.releaseDate"
          label="放行日期："
          readonly
          label-width="100px"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="info.personnelType"
          label="放行人员类型："
          readonly
          label-width="100px"
          v-if="info.personnelType"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="info.carNumber"
          label="放行车辆："
          readonly
          v-if="info.releaseType == 1"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.driverName"
          label="司机："
          readonly
          v-if="info.releaseType == 1"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.driverName"
          label="放行人员："
          readonly
          v-if="info.releaseType == 2 || info.releaseType == 3"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.driverCode"
          label="工号："
          readonly
          v-if="info.driverCode"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.department"
          label="放行人员部门："
          readonly
          v-if="info.department"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.visitorPhone"
          label="手机号码："
          readonly
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.vehicleType"
          label="车辆类型："
          readonly
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.carNumber"
          label="车牌号码："
          readonly
          v-if="info.releaseType == 2 || info.releaseType == 3"
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.beforeImgList"
          label="拍照附件(选填)"
          readonly
          label-width="100px"
        >
          <template #input>
            <van-uploader
              v-model="info.beforeList"
              multiple
              readonly 
              :preview-full-image="false"
            />
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.goodsList"
          label="放行物品："
          readonly
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group>
        <div class="table_content">
          <div class="table_header">
            <div class="left">物品名称</div>
            <div class="right">数量</div>
          </div>
          <div
            class="item_content"
            v-for="(item, index) in info.goods"
            :key="index"
          >
            <div class="item_left">{{ item.goodsName }}</div>
            <div class="item_right">{{ item.goodsNumber }}</div>
          </div>
        </div>
      </van-cell-group>
      <van-cell-group>
        <div class="textareaCon">
          <van-field
            v-model="info.remark"
            rows="4"
            autosize
            label="备注："
            type="textarea"
            readonly
          />
        </div>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.sendBack"
          label="携带的物品是否需送回公司："
          readonly
          label-width="185px"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="info.arriveDate"
          label="预计送回时间："
          readonly
          label-width="100px"
        />
      </van-cell-group>
      <van-cell-group style="padding: 0 20px">
        <div class="flowPath">
          <div class="flowPathTitle">审批流</div>
          <div>
            <div class="container_item">
              <div>
                <div
                  class="handle"
                  v-for="approve in info.approveVOList"
                  :key="approve.id"
                >
                  <div class="handleDiv">
                    <img
                      src="@/assets/mobVisitor/m1.png"
                      alt=""
                      srcset=""
                      style="width: 27px; height: 27px"
                    />
                  </div>
                  <div class="handleRight">
                    <h3 class="rightTitle" v-if="approve.nodeName">
                      <!-- {{ index == 0 ? "直属上级审批" : "审批人" }} -->
                      {{ approve.nodeName }}
                    </h3>
                    <!-- <h3 class="rightTitle" v-if="!approve.nodeName">
                      {{ index == 0 ? "直属上级审批" : "审批人" }}
                    </h3> -->
                    <div class="approver">
                      <div class="approverImg">
                        <span class="clr-span">{{ approve.approveName }}</span>
                      </div>
                      <div class="right">
                        <span
                          style="margin-right: 5px"
                          :style="{
                            color:
                              approve.approveState == '通过'
                                ? '#267ef0'
                                : approve.approveState == '驳回'
                                ? 'red'
                                : ''
                          }"
                          v-if="approve.nodeName"
                        >
                          <!-- {{approve.approveState == '2' ? '已同意' : approve.approveState == '3' ? '已拒绝' : '' }} -->
                          {{ approve.approveState }}
                        </span>
                        <span
                          style="margin-right: 5px"
                          :style="{
                            color:
                              approve.approveState == '2'
                                ? '#267ef0'
                                : approve.approveState == '3'
                                ? 'red'
                                : ''
                          }"
                          v-if="!approve.nodeName"
                        >
                          {{
                            approve.approveState == "2"
                              ? "已同意"
                              : approve.approveState == "3"
                              ? "已拒绝"
                              : ""
                          }}
                          <!-- {{ approve.approveState }} -->
                        </span>
                        <span>{{ approve.approveTime }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import apiss from "@/apis/medal";
export default {
  name: "carCostDetail",
  data() {
    return {
      info: {
        releaseNumber: "",
        createrDepartment: "",
        createrName: "",
        releaseDate: "",
        carNumber: "",
        driverName: "",
        visitorPhone: "",
        goods: [],
        remark: "",
        approveVOList: [],
        beforeList: [],
        beforeImgList: '',
        vehicleType:''
      }
    };
  },
  mounted() {
    this.queryDetailsRelease();
  },
  methods: {
    // 获取放行详情
    queryDetailsRelease() {
      api.queryDetailsRelease({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.$nextTick(() => {
            this.info = res.data;
            this.info.vehicleType = res.data.vehicleType==1?'货车':res.data.vehicleType==2?'面包车':res.data.vehicleType==3?'三轮车':'';
            this.info.sendBack = res.data.sendBack == 1 ? "否" : "是";
            if (res.data.fileIds) {
              const fileIds = res.data.fileIds.split(",");
              this.info.beforeList = fileIds.map(item => {
                return {
                  url: apiss.imgUrl + item,
                  isImage: true
                };
              });
            } else {
              this.info.beforeList = [];
            }
            console.log(4444, this.info);
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .detailContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .detailContainer {
    width: 276px * $zoom;
  }
}

.detailContainer {
  margin: auto;
  background-color: #f3f3f5;

  // display: flex;
  // flex-direction: column;
  .detailContent {
    overflow-y: auto;
    ::v-deep {
      .van-hairline--top-bottom::after,
      .van-hairline-unset--top-bottom::after {
        border: 0;
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
    .table_content {
      background-color: #fff;
      padding: 0 11px * $zoom;

      .table_header {
        height: 26.5px * $zoom;
        border: 1px solid #dfdfdf;
        background: #f7f9fa;
        font-weight: bold;
        font-size: 9.5px * $zoom;
        color: #333333;
        display: flex;

        width: 100%;
        .left {
          width: 70%;
          display: flex;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
          border-right: 1px solid #dfdfdf;
        }
        .right {
          width: 30%;
          display: flex;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
        }
      }
      .item_content {
        height: 26.5px * $zoom;
        border: 1px solid #dfdfdf;
        border-top: 0;
        display: flex;
        .item_left {
          width: 70%;
          display: flex;
          justify-content: flex-start;
          align-content: center;
          flex-wrap: wrap;
          border-right: 1px solid #dfdfdf;
          padding-left: 10px * $zoom;
          font-size: 27px;
        }
        .item_right {
          width: 30%;
          display: flex;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
          font-size: 27px;
        }
      }
    }
    .textareaCon {
      ::v-deep {
        .van-field__label {
          padding: 5px * $zoom;
        }
        .van-cell {
          display: flex;
          flex-direction: column;
        }
        .van-field__body {
          border: 1px solid #c1c1c1;
          border-radius: 2px * $zoom;
        }
        .van-field__control {
          padding: 2px * $zoom 8px * $zoom;
        }
      }
    }
    .flowPath {
      padding: 30px 0;

      .flowPathTitle {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
        margin-bottom: 20px;
      }
    }
    .container_item {
      background: #fff;
      margin-top: 20px;
      padding: 25px;

      .title {
        color: rgba(150, 155, 158, 1);
        font-size: 30px;
      }

      .handle {
        display: flex;
        margin-top: 10px;

        &:last-child {
          .handleDiv::after {
            width: 0;
            height: 0;
          }
        }

        .handleDiv::after {
          display: block;
          content: "";
          width: 1px;
          height: 70px;
          background-color: #ccc;
          position: relative;
          left: 24px;
        }

        .handleRight {
          margin-left: 20px;
          width: calc(100vh);

          .rightTitle {
            margin: 10px 0;
            font-size: 29px;
          }

          .approver {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;

            .approverImg {
              display: flex;
              flex-shrink: 0;
              align-items: center;

              .iconWrapper {
                position: relative;

                .elIcon {
                  position: absolute;
                  left: 40px;
                  top: -10px;
                  font-size: 22px;
                }
              }

              .clr-span {
                display: inline-block;
                border-radius: 20px;
                background-color: rgb(248 250 251);
                margin: 0 5px;
                padding: 10px 0;
                font-size: 24px;
                text-align: center;
                margin-left: 15px;
              }
            }

            .right {
              flex-shrink: 0;
              // margin-left: 30%;
              font-size: 22px;
              color: #9fa2a5;
            }
          }
        }
      }
    }
  }
}
</style>
